/** מה שחלון הסידור עורך, בנפרד מהרכיב כדי שאפשר יהיה לבדוק אותו. */
export type CampaignValues = {
  id: string | null;
  title: string;
  instructions: string;
  referenceImagePath: string | null;
  /** 'YYYY-MM-DD' או ריק. */
  dueDate: string;
  /** ריק = כל הסניפים. */
  branchIds: string[];
};

export const emptyCampaign: CampaignValues = {
  id: null,
  title: '',
  instructions: '',
  referenceImagePath: null,
  dueDate: '',
  branchIds: [],
};

export type BoardCampaign = {
  id: string;
  title: string;
  instructions: string | null;
  reference_image_path: string | null;
  due_date: string | null;
  created_at: string;
  branches: { id: string; name: string; color: string | null }[];
  is_targeted: boolean;
  counts: { branches: number; submitted: number; approved: number; needs_fix: number };
};

export function campaignToValues(campaign: BoardCampaign): CampaignValues {
  return {
    id: campaign.id,
    title: campaign.title,
    instructions: campaign.instructions ?? '',
    referenceImagePath: campaign.reference_image_path,
    dueDate: campaign.due_date ?? '',
    // סידור "לכל הסניפים" נשמר בלי שורות שיוך, ולכן הוא חוזר
    // לחלון כבחירה ריקה ולא כרשימת כל הסניפים
    branchIds: campaign.is_targeted ? campaign.branches.map((branch) => branch.id) : [],
  };
}

/** כמה סניפים עוד לא הגישו כלום. */
export function missingCount(counts: BoardCampaign['counts']) {
  return Math.max(counts.branches - counts.submitted - counts.approved - counts.needs_fix, 0);
}

export type CampaignFilter = 'all' | 'missing' | 'submitted' | 'needs_fix' | 'done';

export const CAMPAIGN_FILTERS: { key: CampaignFilter; label: string }[] = [
  { key: 'all', label: 'הכל' },
  { key: 'missing', label: 'חסרות הגשות' },
  { key: 'submitted', label: 'ממתין לאישור' },
  { key: 'needs_fix', label: 'חזר לתיקון' },
  { key: 'done', label: 'הושלם' },
];

/**
 * האם הסידור עונה על הסינון.
 *
 * "הושלם" הוא כל הסניפים אושרו, ולכן סידור בלי סניפים בכלל אינו
 * הושלם — אין מה לאשר בו.
 */
export function matchesFilter(campaign: BoardCampaign, filter: CampaignFilter) {
  const { counts } = campaign;
  switch (filter) {
    case 'missing':
      return missingCount(counts) > 0;
    case 'submitted':
      return counts.submitted > 0;
    case 'needs_fix':
      return counts.needs_fix > 0;
    case 'done':
      return counts.branches > 0 && counts.approved === counts.branches;
    default:
      return true;
  }
}
